const CdnServerAddress = "https://bdbcdn.bdbdigital.com/";

export {
    CdnServerAddress,
};